/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import React, { useMemo } from "react";

import { ImageHelper, RouteHelper } from "@nf/common";

import { IListComponentItemProps } from "../../models";

import styles from "./ListComponentItemContent.module.scss";
import cx from "classnames";

import dynamic from "next/dynamic";

import { IAppImage } from "../../../../../../AppImage/AppImage";
const AppImage = dynamic<IAppImage>(() =>
  import("components/AppImage/AppImage").then((mod) => mod.AppImage)
);

const LinkWithLocale = dynamic<any>(() =>
  import("components/LinkWithLocale").then((mod) => mod.LinkWithLocale)
);

const imageSize = {
  width: 790,
  height: 526,
};

export const ListComponentItemContent = ({
  rowIndex,
  media,
}: IListComponentItemProps) => {
  const reverseOrder: boolean = rowIndex ? rowIndex % 2 === 0 : true;

  const src = useMemo(
    () => ImageHelper.getHoverAssetImageUrl(media?.Images) || "",
    [media?.Images]
  );
  const linkToDetails = useMemo(() => RouteHelper.goToDetails(media), [media]);

  return (
    <article className={styles.item}>
      <div
        className={cx(styles.background, { [styles.reverseRow]: reverseOrder })}
      >
        <div className={styles.imageContainer}>
          {src && media && (
            <LinkWithLocale href={linkToDetails}>
              {src && (
                <AppImage
                  src={src}
                  width={imageSize.width}
                  height={imageSize.height}
                  alt={media?.Title || ""}
                  className={styles.image}
                  layout="fill"
                  useOriginal
                />
              )}
            </LinkWithLocale>
          )}
        </div>
        <div
          className={cx(styles.container, {
            [styles.containerReverse]: reverseOrder,
          })}
        >
          <LinkWithLocale href={linkToDetails} passHref>
            <a className={styles.title}>{media?.Title}</a>
          </LinkWithLocale>
          <p className={styles.description}>
            {media?.LongDescription || media?.ShortDescription}
          </p>
        </div>
      </div>
    </article>
  );
};
